// See services/sosInventoryService/README.md for information about the structure
// of schema.js files.
export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["quantity"],
  MONEY_FIELDS: ["cost", "revenue", "total"],
  DATE_FIELDS: [],
  DATETIME_FIELDS: ["txnDate"],
  NON_UTC_DATETIME_FIELDS: [],
};
